<template>
  <div>
    <vuedraggable
      @end="draggableEnd"
      tag="div"
      draggable=".artwork-list-item"
      class="artwork-list d-flex"
      v-viewer="{ movable: true }"
      :disabled="disabled"
    >
      <div
        v-for="(item, i) in materialImageList"
        :key="i"
        class="artwork-list-item move"
      >
        <div class="artwork-list-item__image">
          <img
            :src="item.displayImageUrl"
            :style="{ width, height }"
            @click="onPreview"
          />
        </div>

        <span class="mt-2 artwork-list-text" :style="{ width }">{{ item.fileDesc }}</span>
      </div>
    </vuedraggable>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import EditLoading from '@/mixins/edit-loading'

export default {
  components: { vuedraggable },
  mixins: [EditLoading],
  props: {
    amzSkuMaterialCode: String,
    width: {
      type: String,
      default: '100px',
    },
    height: { type: String, default: '100px' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      materialImageList: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取物料图稿文件
    getData() {
      this.materialImageList = []
      this.$api
        .ecomAmzSkuMaterialImageListApi({
          amzSkuMaterialCode: this.amzSkuMaterialCode,
          sortFlag: 'Y',
        })
        .then(({ status, body }) => {
          if (status == 200) {
            this.materialImageList = body.data
          }
        })
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (this.disabled) {
        return
      }
      if (newIndex === oldIndex) return
      const oldEl = { ...this.materialImageList[oldIndex] }
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.materialImageList[i] = this.materialImageList[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = oldIndex; i < newIndex; i++) {
          this.materialImageList[i] = this.materialImageList[i + 1]
        }
      }
      this.materialImageList[newIndex] = oldEl
      this.updateSortOrder(this.materialImageList)
    },
    updateSortOrder(params) {
      this.loadingOpen()
      this.updateOrder(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.getData()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async updateOrder(params) {
      return await this.$api.ecomAmzSkuMaterialImageUpdateSortOrderApi({
        detailList: params.map((item) => item.amzSkuMaterialImgCode) || [],
      })
    },
    onPreview(index) {
      const viewer = this.$el.querySelector('.artwork-list').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.artwork-list {
  flex-wrap: wrap;
}
.artwork-list-item {
  margin-right: 10px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.artwork-list-item__image {
  background-color: rgba(244, 246, 249, 1);
  border-radius: 5px;
  padding: 10px;
}
.artwork-list-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.move {
  cursor: move !important;
}
</style>
